import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaCartPlus, FaTrashAlt } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import { getAmazonAffiliateLink, capitalizeFirstLetterOfEachWordAndShorten, formatPrice, 
  shortenArabicName, handleProductClickAmazon } from '../utils';
import { useCart } from '../context/CartContext'; // adjust path if needed


export default function ProductBox({ product }) {
  const { t, i18n } = useTranslation();
  const { cartItems, addToCart, removeFromCart } = useCart();
  const [inCart, setInCart] = useState(() =>
  cartItems.some(item => item._id === product._id)
);

useEffect(() => {
  setInCart(cartItems.some(item => item._id === product._id));
}, [cartItems, product._id]);


  const recordUserClick = async (item, type) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/main/user/click`, {
        itemId: item._id,
        type,
        name: item.name,
        arabicName: item.arabicName,
        link: item.link,
        store: item.store,
        lang: i18n.language
      }, 
      // { withCredentials: true }
    );
    } catch (err) {
      console.error('Failed to record click:', err);
    }
  };
  

  return (
  <div onClick={() => handleProductClickAmazon(product)} className="group perspective h-full">
  <Link
    onClick={() => recordUserClick(product, "productBox")}
    to={`/product-page/${product._id}`}
    className="card card-compact bg-base-100 shadow-md border border-gray-200 rounded-2xl overflow-hidden transition-transform duration-300 hover:scale-105 group-hover:shadow-lg w-60 flex flex-col h-full"
  >
        <div className="relative">
          <figure className="p-2 bg-white">
            <img
              src={product.image}
              alt={product.name}
              className="max-h-32 w-full object-contain transition-all duration-300 group-hover:scale-105"
              onError={(e) => {
                e.target.src = '/logo2.png';
              }}
            />
          </figure>
          <div
  className="absolute top-2 right-2 text-lg cursor-pointer z-10"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
  
    if (inCart) {
      removeFromCart(product._id);
      toast.success(t('Removed from cart'));
    } else {
      addToCart({ ...product, quantity: 1 }); // or however you define quantity
      toast.success(t('Added to cart'));
    }
  
    setInCart(!inCart);
  }}
  
>
  {inCart ? (
    <FaTrashAlt className="text-red-500 hover:text-red-700" />
  ) : (
    <FaCartPlus className="text-xl hover:text-green-600 text-primary" />
  )}
</div>

          {/* <div
            className="absolute top-2 right-2 text-red-500 text-lg cursor-pointer z-10"
            onClick={(e) => {
              e.preventDefault();
              setLiked(!liked);
            }}
          >
            {liked ? <FaTrashAlt /> : <FaCartPlus className="text-xl cursor-pointer hover:fill-[rgb(62,43,205)] fill-primary" />}
          </div> */}
        </div>

        {/* <div className="card-body px-3 py-2"> */}
        <div className="card-body px-3 py-2 flex flex-col justify-between flex-grow dark:bg-slate-600">
          <h2 className="card-title text-sm font-medium text-gray-800 break-words leading-tight line-clamp-2 min-h-[2.75rem] dark:text-white">
          {i18n.language === 'ar' && product.arabicName
            ? shortenArabicName(product.arabicName)
            : capitalizeFirstLetterOfEachWordAndShorten(product.name)}
        </h2>


          {/* Price */}
          <div className="mt-1">
            {/* {product.prices.discounted ? (
              <div>
                <span className="text-primary font-semibold text-sm discounted-price-productBox">
                  {`${t('priceBox.now')} ${formatPrice(product.prices.discounted)} ${product.currency}`}
                </span>
                <span className="line-through text-xs text-gray-400 ml-2 original-price-productBox">
                  {formatPrice(product.prices.original)} {product.currency}
                </span>
                {product.discountPercentage && (
                  <div className="badge badge-error badge-sm mt-1">
                    {product.discountPercentage}% OFF
                  </div>
                )}
              </div>
            ) : (
              <span className="text-sm text-gray-800 original-price-productBox">
                {`${t('priceBox.now')} ${formatPrice(product.prices.original)} ${product.currency}`}
              </span>
            )} */}
            {product.prices.discounted &&
 product.prices.discounted !== product.prices.original ? (
  <div>
    <span className="text-primary font-semibold text-sm discounted-price-productBox">
      {`${t('priceBox.now')} ${formatPrice(product.prices.discounted)} ${product.currency}`}
    </span>
    <span className="line-through text-xs text-gray-400 ml-2 original-price-productBox">
      {formatPrice(product.prices.original)} {product.currency}
    </span>
    {product.discountPercentage && (
      <div className="badge badge-error badge-sm mt-1">
        {product.discountPercentage}% OFF
      </div>
    )}
  </div>
) : (
  <span className="text-primary font-semibold text-sm original-price-productBox">
    {`${t('priceBox.now')} ${formatPrice(product.prices.discounted || product.prices.original)} ${product.currency}`}
  </span>
)}

          </div>

          {/* Stars */}
          {/* <div className="flex space-x-1 text-yellow-400 mt-1">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="text-xs" />
            ))}
          </div> */}

          {/* Store + Info */}
          {/* <div className="mt-2 flex justify-between items-center text-xs">
            <img
              src={product.storeLogo}
              alt={product.store}
              className="h-4"
              onError={(e) => (e.target.src = '/logo2.png')}
            />
          </div> */}


<button
  onClick={async (e) => {
    e.stopPropagation(); // Prevents triggering parent click
    e.preventDefault(); // Prevents navigation from <Link>

    // Open the affiliate link in a new tab first
    const link = await getAmazonAffiliateLink(product.link, product.store);
    
    if (link) {
      // Open the link immediately, so the browser doesn't block it
      const newWindow = window.open(link, "_blank");

      // Ensure the new window opened
      if (newWindow) {
        // Wait for the click to be recorded after opening the link
        try {
          await recordUserClick(product, "viewOnStore");
        } catch (err) {
          console.error("Error during click recording:", err);
        }
      } else {
        console.error("Popup blocked by browser");
      }
    }
  }}
  className="rounded-xl btn bg-[#FF9900] text-white hover:bg-[rgb(62,43,205)] border-none rounded-lg w-full mt-4"
>
  {`View at ${product.store}`}
</button>



{/* <button
  onClick={async (e) => {
    e.stopPropagation(); // Prevents triggering parent click
    e.preventDefault(); // Prevents navigation from <Link>

    await recordUserClick(product, "viewOnStore");

    const link = await getAmazonAffiliateLink(product.link, product.store);
    if (link) {
      window.open(link, "_blank");
    }
  }}
  className="rounded-xl btn bg-[#FF9900] text-white hover:bg-[#FF8C00] border-none rounded-lg w-full mt-4"
>
{`View at ${product.store}`}
</button> */}


        </div>
      </Link>
    </div>
  );
}